import React, { useState } from 'react';

import SignupForm from './SignupForm';
import SSOSigninSignUpForm from '../sso/SSOSigninSignUpForm';

const pageCount = 3;

const SignUp = ({ locales, data }) => {
  const { onboarding: pageLocales } = locales;
  const establishmentIsStandardAuthAllowed = JSON.parse(
    data.establishmentIsStandardAuthAllowed,
  );
  const establishmentIsSsoAuthAllowed = JSON.parse(
    data.establishmentIsSsoAuthAllowed,
  );

  const [step, setStep] = useState(1);

  return (
    <>
      {establishmentIsStandardAuthAllowed && (
        <>
          <p className="sign-up-form-section__step-counter">
            {pageLocales.common.step} {step} {pageLocales.common.of} {pageCount}
          </p>
          <div className="sign-up-form-section__step-dots">
            {new Array(3).fill(1).map((_, index) => (
              <div
                key={index}
                className={`sign-up-form-section__step-dots-item ${
                  index < step ? 'active' : ''
                }`}
                onClick={() => setStep(index + 1)}
              />
            ))}
          </div>
          <SignupForm
            locales={locales}
            data={data}
            step={step}
            setStep={setStep}
          />
        </>
      )}
      {establishmentIsStandardAuthAllowed && establishmentIsSsoAuthAllowed && (
        <hr style={{ margin: '3rem 0', color: 'white' }} />
      )}
      {!establishmentIsStandardAuthAllowed && establishmentIsSsoAuthAllowed && (
        <h3 className="text-3xl text-white font-bold pt-12">
          {locales.onboarding.titles.step1Sso}
        </h3>
      )}
      {establishmentIsSsoAuthAllowed && (
        <SSOSigninSignUpForm data={data} locales={pageLocales} />
      )}
    </>
  );
};

export default SignUp;
